import App from "@/App.vue";

export default [
  {
    path: "/lista-cotacoes",
    name: "quotation",
    component: App,
    redirect: { name: "quotation list" },
    children: [
      {
        path: "",
        name: "quotation list",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/QuotationList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Cotações",
              disabled: false,
              link: false,
              to: { name: "quotation" }
            }
          ],
          displayName: "Lista Cotações - Lockton",
          requiresAuth: true
        }
      }
    ]
  },

  {
    path: "/nova-cotacao",
    name: "add quotation",
    component: App,
    redirect: { name: "new quotation" },
    children: [
      {
        path: "",
        name: "new quotation",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewQuotation.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Nova Cotação",
              disabled: false,
              link: false,
              to: { name: "add quotation" }
            }
          ],
          displayName: "Nova Cotação - Lockton",
          requiresAuth: true
        }
      }
    ]
  },
  {
    // Cotação de um usuáro convidado
    path: "/nova-cotacao/agro/:groupId?/:officeId?",
    name: "add quotation agro guest",
    component: App,
    redirect: { name: "new quotation agro guest" },
    children: [
      {
        path: "",
        name: "new quotation agro guest",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewQuotationAgroGuest.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Nova Cotação",
              disabled: false,
              link: false,
              to: { name: "add quotation agro guest" }
            }
          ],
          displayName: "Nova Cotação - Lockton",
          requiresAuth: false
        }
      }
    ]
  },
  {
    // Tela para imprimir a cotação agro
    path: "/print-quotation/:id/:token?",
    name: "quotation agro",
    props: route => ({
      params: route.params.isTableView,
      isGranizo: route.params.isGranizo
    }),
    component: App,
    redirect: { name: "quotation agro" },
    children: [
      {
        path: "",
        name: "quotation agro",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/PrintQuotationAgro.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: true,
              to: { name: "quotation agro" }
            }
          ],
          displayName: "Cotação - Lockton",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/cotacao/:id",
    name: "quotation element",
    component: App,
    redirect: { name: "status quotation" },
    children: [
      {
        path: "",
        name: "status quotation",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/StatusQuotation.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: true,
              to: { name: "quotation" }
            }
          ],
          displayName: "Cotação - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "nova-critica",
        name: "quotation new criticism",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewCriticism.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Críticas",
              disabled: false,
              link: true,
              to: { name: "quotation element" }
            }
          ],
          displayName: "Nova Crítica - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "inserir-minuta",
        name: "quotation new draft contract",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewDraftContract.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: true,
              to: { name: "quotation element" }
            }
          ],
          displayName: "Inserir Minuta - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "criticas",
        name: "quotation criticism",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Criticism.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: true,
              to: { name: "quotation element" }
            }
          ],
          displayName: "Críticas - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "declinar-minuta",
        name: "quotation reject draft contract",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/RejectDraftContract.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: true,
              to: { name: "quotation element" }
            }
          ],
          displayName: "Declinar Minuta - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "editar-minuta",
        name: "quotation edit draft contract",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditDraftContract.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Editar minuta",
              disabled: false,
              link: true,
              to: { name: "quotation element" }
            }
          ],
          displayName: "Editar Minuta - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "editar-cotacao",
        name: "edit quotation",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditQuotation.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Editar dados",
              disabled: false,
              link: false,
              to: { name: "quotation" }
            }
          ],
          requiresAuth: true,
          displayName: "Editar Cotação - Lockton"
        }
      },
      {
        path: "inserir-apolice",
        name: "quotation new policy contract",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewPolicy.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: false,
              to: { name: "quotation" }
            }
          ],
          requiresAuth: true,
          displayName: "Inserir Apólice - Lockton"
        }
      },
      {
        path: "resumo-cotacao",
        name: "quotation resume",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ResumeProcess.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: false,
              to: { name: "quotation" }
            }
          ],
          requiresAuth: true,
          displayName: "Resumo da Cotação - Lockton"
        }
      },
      {
        path: "historico-cotacao",
        name: "quotation historical",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/HistoricalQuotation.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: false,
              to: { name: "quotation" }
            }
          ],
          requiresAuth: true,
          displayName: "Histórico da Cotação - Lockton"
        }
      },
      {
        path: "historico-cotacao-agro",
        name: "quotation historical agro",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/HistoricalQuotationAgro.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: true,
              to: { name: "quotation" }
            }
          ],
          requiresAuth: true,
          displayName: "Histórico da Cotação Agro - Lockton"
        }
      },
      {
        path: "resumo-cotacao-agro",
        name: "quotation resume agro",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ResumeProcessAgro.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Cotação",
              disabled: false,
              link: true,
              to: { name: "quotation" }
            }
          ],
          requiresAuth: true
          // displayName: "Resumo da Cotação Agro - Lockton"
        }
      }
    ]
  }
];
